export default __webpack_public_path__ + "static/media/brainstormingEl.d0eb29eb.png";